import { z } from 'zod'

import type { UserMutator as UM } from '../schemas/public/User.js'
import { userMutator as uM } from '../schemas/public/User.js'

export type ExtendedUserMutator = UM & {
  password?: string
  passwordConfirm?: string
} & {
  passwordHash?: string
  passwordSalt?: string
}

const passwordField = z.object({
  password: z
    .string()
    .superRefine((val, ctx) => {
      const containsNumber = (ch: string) => /[0-9]/.test(ch)
      const containsUppercase = (ch: string) => /[A-Z]/.test(ch)
      const containsLowercase = (ch: string) => /[a-z]/.test(ch)
      const containsSpecialChar = (ch: string) =>
        /[`!@#$%^&*()_\-+=[\]{};':"\\|,.<>/?~ ]/.test(ch)

      const error =
        'password must bet at least 10 characters and contain at least one of each: lowercase, uppercase, special character, number'

      if (
        val !== '' &&
        val !== undefined &&
        !(
          containsNumber(val) &&
          containsUppercase(val) &&
          containsLowercase(val) &&
          containsSpecialChar(val) &&
          val.length >= 10
        )
      ) {
        ctx.addIssue({
          code: 'custom',
          message: error,
        })
      }
    })
    .optional(),
  passwordConfirm: z.string().optional(),
})

export const extendedUserMutator = z
  .object({
    ...passwordField.shape,
    ...(uM as unknown as z.ZodObject<any>).shape,
    passwordHash: z.string().optional(),
    passwordSalt: z.string().optional(),
  })
  .superRefine(({ passwordConfirm, password }, ctx) => {
    if (passwordConfirm !== undefined && passwordConfirm !== password)
      ctx.addIssue({
        code: 'custom',
        message: 'The passwords did not match',
        path: ['passwordConfirm'],
      })
  }) as unknown as z.Schema<ExtendedUserMutator>
